import { Grid, Typography, Switch } from "@mui/material";
import React, { useEffect, useCallback, useMemo } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Slider from "@mui/material/Slider";
import {
  setCaracteristicas,
  setOperations,
  setProperty,
} from "../redux/actions/productsActions";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useAutocomplete } from "@mui/base/AutocompleteUnstyled";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";

const Root = styled("div")(
  ({ theme }) => `
  color: ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.65)" : "rgba(0,0,0,.85)"
  };
  font-size: 14px;
`
);
const Label = styled("label")`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;
const InputWrapper = styled("div")(
  ({ theme }) => `
  width: 300px;
  border: 1px solid ${theme.palette.mode === "dark" ? "#434343" : "#d9d9d9"};
  background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
  }

  &.focused {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
    color: ${
      theme.palette.mode === "dark"
        ? "rgba(255,255,255,0.65)"
        : "rgba(0,0,0,.85)"
    };
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`
);
function Tag(props) {
  const { label, onDelete, ...other } = props;
  return (
    <div {...other}>
      <span>{label}</span>
      <CloseIcon onClick={onDelete} />
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
};
const StyledTag = styled(Tag)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: ${
    theme.palette.mode === "dark" ? "rgba(255,255,255,0.08)" : "#fafafa"
  };
  border: 1px solid ${theme.palette.mode === "dark" ? "#303030" : "#e8e8e8"};
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: ${theme.palette.mode === "dark" ? "#177ddc" : "#40a9ff"};
    background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`
);

const Listbox = styled("ul")(
  ({ theme }) => `
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: ${theme.palette.mode === "dark" ? "#141414" : "#fff"};
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected='true'] {
    background-color: ${theme.palette.mode === "dark" ? "#2b2b2b" : "#fafafa"};
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li.${autocompleteClasses.focused} {
    background-color: ${theme.palette.mode === "dark" ? "#003b57" : "#e6f7ff"};
    cursor: pointer;

    & svg {
      color: currentColor;
    }
  }
`
);

const Filtro = () => {
  const [state, setState] = React.useState({
    checkedA: true,
  });
  const [checked, setChecked] = React.useState([true, false]);
  const [operation, setOperation] = React.useState("");
  const [range, setRange] = React.useState([150000, 370000]);

  let caracteristics = useSelector((state) => state.allProducts.caracteristica);
  let operations = useSelector((state) => state.allProducts.operation);
  let typeProperties = useSelector((state) => state.allProducts.property);
  const dispatch = useDispatch();
  const rangeSelector = (event, newValue) => {
    setRange(newValue);
    console.log(newValue);
  };
  const fetchCaracteristics = async () => {
    const response = await axios
      .get("https://back.rentti.cl/v1/property/specificCharacteristics")
      .catch((err) => {
        console.log("Err: ", err);
      });
    dispatch(setCaracteristicas(response.data));
  };
  const fetchOperation = async () => {
    const response = await axios
      .get("https://back.rentti.cl/v1/property/operation")
      .catch((err) => {
        console.log("Err: ", err);
      });
    dispatch(setOperations(response.data));
  };
  const fetchTypeProperty = async () => {
    const response = await axios
      .get("https://back.rentti.cl/v1/property/propertyNu")
      .catch((err) => {
        console.log("Err: ", err);
      });
    dispatch(setProperty(response.data));
  };
  useEffect(() => {
    fetchCaracteristics();
    fetchOperation();
    fetchTypeProperty();
  }, []);

  const handleChangeC = (event) => {
    setChecked([event.target.checked, event.target.checked]);
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl,
  } = useAutocomplete({
    id: "customized-hook-demo",
    defaultValue: [top100Films[1]],
    multiple: true,
    options: top100Films,
    getOptionLabel: (option) => option.nombre,
  });

  return (
    <Grid container justifyContent="center" alignContent="center">
      <Grid item xs={9} mt={1} marginLeft="30px" p={1}>
        <Typography variant="subtitle2" mt={1} marginRight="30px">
          Tipo Propiedad
        </Typography>
        {typeProperties.map((item) => (
          <FormControlLabel
            sx={{
              display: "block !important",
              padding: "5px 10px !important",
            }}
            value="start"
            control={<Checkbox />}
            label={item.nombre}
            labelPlacement="start"
            gutterBottom
          />
        ))}
      </Grid>
      <Grid item xs={9} mt={1} marginLeft="30px" p={1}>
        <Typography variant="subtitle2" mt={1} marginRight="30px">
          Operación
        </Typography>
        {operations.map((item) => (
          <FormControlLabel
            sx={{
              display: "block !important",
              padding: "5px 10px !important",
            }}
            value="start"
            control={<Checkbox />}
            label={item.nombre}
            labelPlacement="start"
            gutterBottom
          />
        ))}
      </Grid>
      <Grid item xs={9} mt={1} marginLeft="30px" p={1}>
        <Root>
          <div {...getRootProps()}>
            <Label {...getInputLabelProps()}>Caracteristica</Label>
            <InputWrapper ref={setAnchorEl}>
              {value.map((option, index) => (
                <StyledTag label={option.nombre} {...getTagProps({ index })} />
              ))}
              <input {...getInputProps()} />
            </InputWrapper>
          </div>
        </Root>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.nombre}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </Grid>
      <Grid item xs={9} mt={1} marginLeft="30px" p={1}>
        <Typography
          variant="subtitle2"
          mb={"10px !important"}
          marginRight="30px"
        >
          Precio
        </Typography>
        <Typography variant="body1" mb={"10px !important"} marginRight="30px">
          $ 94.900.000 a $ 95.000.000 (3)
        </Typography>
        <Typography variant="body1" mb={"20px !important"} marginRight="30px">
          $ 95.000.000 a $ 98.900.000 (490)
        </Typography>
        <Grid item textAlign={"left"}>
          <Slider
            min={90000}
            max={700000}
            size="small"
            value={range}
            onChange={rangeSelector}
            valueLabelDisplay="auto"
            color="primary"
          />
          <Typography>
            Buscar de ${range[0]} a ${range[1]}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Filtro;

const top100Films = [
  { nombre: "The Shawshank Redemption", year: 1994 },
  { nombre: "The Godfather", year: 1972 },
  { nombre: "The Godfather: Part II", year: 1974 },
  { nombre: "The Dark Knight", year: 2008 },
  { nombre: "12 Angry Men", year: 1957 },
  { nombre: "Schindler's List", year: 1993 },
  { nombre: "Pulp Fiction", year: 1994 },
];
